var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"schedule"}},[(!_vm.loaded)?_c('Preloader'):_vm._e(),_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row p-2"},[_c('div',{staticClass:"col-12",domProps:{"innerHTML":_vm._s(_vm.pageContent)}})])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }